export enum Status {
  new = 'New',
  inProgress = 'In Progress',
  completed = 'Completed',
}
export enum Level {
  easy = 'Easy',
  challenging = 'Challenging',
  completed = 'Completed',
}
